import { render, staticRenderFns } from "./TopContentPrivacyPolicy.vue?vue&type=template&id=2e730688&scoped=true&"
import script from "./TopContentPrivacyPolicy.vue?vue&type=script&lang=ts&"
export * from "./TopContentPrivacyPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./TopContentPrivacyPolicy.vue?vue&type=style&index=0&id=2e730688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e730688",
  null
  
)

export default component.exports